import { ReferenceLocation, ReferenceLocationType } from '@/types';

const LOCATION_TYPES: ReferenceLocationType[] = ['ZIP', 'PLACE', 'MUNICIPALITY'];

const isBrokerLocationType = (value: string): value is ReferenceLocationType =>
  LOCATION_TYPES.includes(value as ReferenceLocationType);

export type BrokerLocationUrlParams = {
  locType?: string | null;
  locCode?: string | null;
  locName?: string | null;
  locPostcode?: string | null;
  town?: string | null;
  zip?: string | null;
};

export const buildLocationFromUrlParams = ({
  locType,
  locCode,
  locName,
  locPostcode,
  town,
  zip,
}: BrokerLocationUrlParams): ReferenceLocation[] => {
  if (locType && isBrokerLocationType(locType) && locCode && locName) {
    return [
      {
        type: locType,
        code: locCode,
        name: locName,
        ...(locPostcode ? { postcode: locPostcode } : {}),
      },
    ];
  }

  if (zip) {
    return [{ type: 'ZIP', code: zip, name: zip }];
  }

  if (town) {
    return [{ type: 'PLACE', code: town, name: town }];
  }

  return [];
};
